// ============================================================================
// PairsForm — « Peut-on proposer à cette personne de candidater à l'animation
// Inter ? » : UNE règle pour le menu, le bouton « + », la carte d'accueil et
// la page de candidature (audit FX 2026-10-13, « frontière trop perméable »).
// ============================================================================
// La matrice accorde `ANIMATEUR.candidature.postuler` à tout participant des
// orgs Cecodev et Inter : la permission seule ouvrait la porte à qui n'a
// jamais suivi de Module. Verrou métier (FX 2026-08-19, posé jusqu'ici sur le
// seul menu) : sans badge ni fiche animateur, pas d'espace animateur — la
// porte d'entrée reste « Me former à l'animation ». Le serveur applique le
// même verrou (403 BADGE_REQUIS).
// ============================================================================

import { useAuth } from "../contexts/AuthContext";
import { useCan } from "./usePermissions";

interface CandidatureAnimateur {
  /** Afficher la porte « Devenir animateur (Inter) ». */
  visible: boolean;
  /** La permission brute, sans le verrou badge. */
  peutPostuler: boolean;
  /** Badge effectif ou fiche animateur : la personne relève de l'animation. */
  releveDeLAnimation: boolean;
}

export function useCandidatureAnimateur(): CandidatureAnimateur {
  const { user } = useAuth();
  const peutPostuler = useCan("ANIMATEUR.candidature.postuler");
  const releveDeLAnimation = Boolean(user?.estAnimateur) || !!user?.niveauCertification;
  const visible = peutPostuler && !(user?.plateformeActif ?? false) && releveDeLAnimation;
  return { visible, peutPostuler, releveDeLAnimation };
}
